import React, { useState } from 'react';
import { Button, Container, Group, Tabs, Title } from '@mantine/core';
import {
  IconArrowLeft,
  IconCloudDownload,
  IconCloudUpload,
  IconDatabase,
} from '@tabler/icons-react';
import BackupPanel from './connectTransfer/BackupPanel';
import TransferPanel from './connectTransfer/TransferPanel';

const ConnectExporter = ({ onBackToOptionSelector }) => {
  const [tab, setTab] = useState('backup');
  return (
    <Container size="lg" py="xl">
      <Group justify="space-between" mb="md">
        <Group gap="sm">
          <IconDatabase size={28} />
          <Title order={2}>Webex Connect Exporter</Title>
        </Group>
        {onBackToOptionSelector && (
          <Button
            variant="subtle"
            leftSection={<IconArrowLeft size={16} />}
            onClick={onBackToOptionSelector}
          >
            Back to Cisco home
          </Button>
        )}
      </Group>

      <Tabs value={tab} onChange={setTab} color="blue">
        <Tabs.List mb="md">
          <Tabs.Tab value="backup" leftSection={<IconCloudDownload size={14} />}>
            Backup / Download
          </Tabs.Tab>
          <Tabs.Tab value="transfer" leftSection={<IconCloudUpload size={14} />}>
            Transfer (source → target)
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="backup">
          <BackupPanel />
        </Tabs.Panel>
        <Tabs.Panel value="transfer">
          <TransferPanel />
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
};

export default ConnectExporter;
